import Landing from './Landing.svelte';
import Keycloak from "keycloak-js";
import "./main.css"
import "chota"

const keycloak = new Keycloak({
    url: 'https://auth.aur.rocks',
    realm: 'kkinc',
    clientId: 'landing',
})

// noinspection JSUnusedGlobalSymbols
export default new Landing({
    target: document.body,
    props: {
        keycloak: keycloak
    }
});
